import { getAchAccountsExcludingAD } from '../../../../API/order/escrow/EscrowAPI';
import { createKeyedDataAsyncSlice } from '../../../createKeyedDataAsyncSlice';

export const { slice: getAchAccountsExcludingADSlice, asyncAction: getAchAccountsExcludingADAction } =
  createKeyedDataAsyncSlice(
    'getAchAccountsExcludingAD',
    getAchAccountsExcludingAD,
    (escrowFileId: string) => escrowFileId
  );
